import React, { useState, useRef, useEffect } from "react";
import footballVideo from "../../asset/video/football.mp4";
import { FaCirclePlay } from "react-icons/fa6";
import { FaCirclePause } from "react-icons/fa6";
import { getCmsImage } from "../actions/cms";
import config from "../config/config";

const CMS_VIDEO_IDENTIFIER = "video";

function VideoSec() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [play, setPlay] = useState(true);
  const [videoSrc, setVideoSrc] = useState(footballVideo);
  const cmsurl = `${config.API_URL}/public/cms/`;

  const videoRef = useRef(null);
  const playPauseOverlayRef = useRef(null);

  useEffect(() => {
    fetchCMSImages();
  }, []);

  const fetchCMSImages = async () => {
    try {
      const { status, result } = await getCmsImage();
      if (status !== true || !Array.isArray(result)) {
        return;
      }

      const cmsVideoFile = result.find(
        (entry) =>
          (entry?.identifier || "").trim().toLowerCase() === CMS_VIDEO_IDENTIFIER
      )?.image?.[0];

      if (cmsVideoFile) {
        setVideoSrc(`${cmsurl}${cmsVideoFile}`);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const togglePlayPause = () => {
    if (videoRef.current.paused) {
      setPlay(false);
      setTimeout(() => {
        if (playPauseOverlayRef.current) {
          playPauseOverlayRef.current.style.opacity = 0;
        }
      }, 1000);
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      setPlay(true);
      if (playPauseOverlayRef.current) {
        playPauseOverlayRef.current.style.opacity = 1;
      }
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="position-relative videsec_rela">
      <video
        ref={videoRef}
        src={videoSrc}
        onError={() => setVideoSrc(footballVideo)}
        controls={play ? false : true}
        width="100%"
      />
      <div className="position-absolute video-bg-btn">
        <button
          ref={playPauseOverlayRef}
          onClick={togglePlayPause}
          id="play_pause_btn">
          {isPlaying ? (
            <>
              <div className="d-flex justify-content-center align-items-center">
                <FaCirclePause className="play_pause_icon me-2" size={13} />
                <span className="play_pause_txt">Pause Now</span>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex justify-content-center align-items-center">
                <FaCirclePlay className="play_pause_icon me-2" size={13} />
                <span className="play_pause_txt">Play Now</span>
              </div>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
export default VideoSec;
